module.exports = __webpack_public_path__ + "public/files/img/1.16591cb5.png";